import React from 'react';
import PropTypes from 'prop-types';
import { BLAZE_DEFAULT_MIN_QUANTITY, QUANTITY_STRING } from '../constants';
import QuantityButtons from '../QuantityButtons';

const CartQuantityInput = ({
  quantity,
  selectedVariant,
  handleOnChange,
  className,
  minValue,
  maxValue
}) => (
  <div className={`${className}__quantity`}>
    <label htmlFor="cart-quantity">{QUANTITY_STRING}</label>
    <QuantityButtons
      minValue={minValue || BLAZE_DEFAULT_MIN_QUANTITY}
      maxValue={maxValue}
      initialValue={quantity}
      handleQuantityUpdate={handleOnChange}
    />
  </div>
);

CartQuantityInput.propTypes = {
  quantity: PropTypes.number.isRequired,
  selectedVariant: PropTypes.string.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
  minValue: PropTypes.string,
  maxValue: PropTypes.string
};

CartQuantityInput.defaultProps = {
  minValue: undefined,
  maxValue: undefined
};

export default CartQuantityInput;
